import cn from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import './styles.scss';

import Div from 'components/common/Div';
import Img from 'components/common/Img';
import { icStar, icStarActive } from 'redhotpie-shared-lib/themes/ImagesSVG';

const StarRate = props => {
  const { callback, score } = props;
  const [stars, setStarts] = useState([
    {
      id: 1,
      ic: icStar,
    },
    {
      id: 2,
      ic: icStar,
    },
    {
      id: 3,
      ic: icStar,
    },
    {
      id: 4,
      ic: icStar,
    },
    {
      id: 5,
      ic: icStar,
    },
  ]);
  const existsCallback = typeof callback === 'function';

  function handleSelectStar(index, isCallCallback = true) {
    const newList = [];
    let count = 0;
    stars.forEach((s, idx) => {
      let { ic } = s;
      if (idx <= index) {
        ic = icStarActive;
        count += 1;
      } else {
        ic = icStar;
      }
      newList.push({ ...s, ic });
    });
    setStarts(newList);
    if (typeof callback === 'function' && isCallCallback) {
      callback(count);
    }
  }

  useEffect(() => {
    handleSelectStar(score - 1, false);
  }, [score]);

  return (
    <div className="group-star">
      {stars.map((s, idx) => {
        return (
          <Div
            className={cn('star', { 'no-cursor': !existsCallback })}
            key={s.id}
            onClick={!existsCallback ? undefined : () => handleSelectStar(idx)}>
            <Img src={s.ic} alt={`ic-${s.id}`} />
          </Div>
        );
      })}
    </div>
  );
};

StarRate.propTypes = {
  callback: PropTypes.func,
  score: PropTypes.oneOf([1, 2, 3, 4, 5]),
};

export default StarRate;
